import * as React from 'react';
import { InputGroupAddon, InputGroupText } from 'reactstrap';
import { mergeClasses, noOp } from '../constants';

type Props = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onClick: () => any;
};

export default class InputFieldAddonButton extends React.Component<Props> {
  render() {
    const { children, className, disabled = false, onClick } = this.props;
    return (
      <InputGroupAddon addonType="append">
        <InputGroupText
          className={mergeClasses([
            'cursor-pointer',
            disabled ? 'disabled' : null,
            className,
          ])}
          onClick={disabled ? noOp : onClick}
        >
          {children}
        </InputGroupText>
      </InputGroupAddon>
    );
  }
}
